<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.39961 9.94922C7.37424 11.762 6.09961 14.1672 6.09961 17.0993C6.09961 22.567 10.532 26.9995 15.9996 26.9995C21.4672 26.9995 25.8996 22.567 25.8996 17.0993C25.8996 14.1672 24.625 11.762 22.5996 9.94922"
      stroke="#252525"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 5V14.9002M16 5C15.2297 5 13.7907 7.19378 13.25 7.75006M16 5C16.7702 5 18.2093 7.19378 18.75 7.75006"
      stroke="#252525"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
